import React from "react";
import cx from "classnames";
import moment from "moment";

import Button from "../../../components/Button";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import { openLinkNewTab } from "../../../../utils/utils";

export default function Footer({
  dataLink = [],
  isJoin = false,
  isReservation = false,
}) {
  return (
    <div className={isJoin && styles.wrapperBottom} id="footer">
      <div
        className={cx(
          !isReservation && styles.footerWrapper,
          !isJoin && !isReservation && styles.footerWrapperNoJoin,
          isReservation && styles.footerReservation
        )}
      >
        {isJoin && (
          <div className={styles.joinWrapper}>
            <p>Konsultasikan Kebutuhan Klinik Anda</p>
            <Button
              label="Hubungi Kami"
              variant="success"
              className={styles.joinButton}
              onClick={() =>
                openLinkNewTab(`${process.env.REACT_APP_CALL_SCRAPER}`)
              }
            />
          </div>
        )}
        {!isReservation && (
          <div className={styles.footerIconWrapper}>
            <img src="/assets/svg/icon-facebook.svg" alt="" />
            <img src="/assets/svg/icon-instagram.svg" alt="" />
            <img src="/assets/svg/icon-whatsapp.svg" alt="" />
            <img src="/assets/svg/icon-linkedin.svg" alt="" />
          </div>
        )}
        {dataLink.length > 0 && (
          <div className={styles.footerLinkWrapper}>
            {dataLink.map((item, index) =>
              item.isLink ? (
                <Link to={item.url} passHref>
                  <a key={index} href="/">
                    {item.label}
                  </a>
                </Link>
              ) : (
                <a href={item.url} key={index}>
                  {item.label}
                </a>
              )
            )}
          </div>
        )}
        <p className={styles.footerCopyRight}>
          Copyright © {moment().year()} Sistem Klinik - CV DINAMIKA SINERGY
          ABADI
        </p>
      </div>
    </div>
  );
}
